import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { BookCategory } from "@modules/bookCategories/types";

export function useBookCategoriesList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createBookCategoriesModalRef = useRef<ModalRef>(null);
  const editBookCategoriesModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<BookCategory>({
    resource: "v1/book_category_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createBookCategoriesModalRef,
    editBookCategoriesModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
